// apps/web/src/components/primitives/isian/tekan.ts
/**
 * Whether a pointer is pressed on the page, and the work held until it is let go (the test sweep
 * of 2026-10-04, B3: leaving a field by pressing the form's button checked the field again on
 * blur, its sentence and the summary of problems above went, the button moved up before the
 * release, and the click landed on empty space; "Lanjut ke peserta" and "Simpan, entri
 * berikutnya" needed a second click). A form holds what would move its layout (a check on blur,
 * the summary's rows) while a pointer is down, and does it once the release's click has been
 * dispatched, so one click lands where it was aimed. A keyboard holds nothing.
 *
 * One set of listeners per document, on the capture phase. The release is the pointer let go
 * (or cancelled); a move with no button down, or the window losing focus, also counts, so a
 * release the page never heard holds nothing for long.
 */

let ditekan = false
const tertunda = new Set<() => void>()
const terpasang = new WeakSet<Document>()

function lepas(): void {
  if (!ditekan) return
  ditekan = false
  // The click follows the release in the same task: the held work runs a turn later.
  setTimeout(() => {
    const kerja = [...tertunda]
    tertunda.clear()
    for (const k of kerja) k()
  }, 0)
}

/** Listens for presses on `dok` (once per document). */
export function pasangTekan(dok: Document): void {
  if (terpasang.has(dok)) return
  terpasang.add(dok)
  dok.addEventListener(
    'pointerdown',
    () => {
      ditekan = true
    },
    true,
  )
  dok.addEventListener('pointerup', lepas, true)
  dok.addEventListener('pointercancel', lepas, true)
  dok.addEventListener(
    'pointermove',
    (event) => {
      if (event.buttons === 0) lepas()
    },
    true,
  )
  dok.defaultView?.addEventListener('blur', lepas)
}

/** A pointer is pressed now. */
export function sedangDitekan(): boolean {
  return ditekan
}

/** Runs `kerja` now, or once the pointer pressed now is let go (each piece of work once). */
export function setelahTekan(kerja: () => void): void {
  if (ditekan) tertunda.add(kerja)
  else kerja()
}
